module.exports = __webpack_public_path__ + "static/media/008-dental drill.4b6013dc.svg";